import React from "react";

export default function Logo({ className = "", variant = "dark" }) {
  const ink = variant === "dark" ? "#0d1117" : "#f6f0e2";
  const accent = "#c8622a";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-label="Zantravora">
      <svg width="30" height="30" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect x="6" y="28" width="12" height="32" fill={ink}/>
        <rect x="22" y="10" width="14" height="50" fill={accent}/>
        <rect x="40" y="22" width="12" height="38" fill={ink}/>
        <circle cx="29" cy="18" r="1.6" fill={ink === "#0d1117" ? "#f6f0e2" : "#0d1117"}/>
      </svg>
      <span className="zv-serif" style={{ color: ink, fontWeight: 600, fontSize: 22, letterSpacing: "-0.02em" }}>
        Zantravora
      </span>
    </span>
  );
}
